{"version":"0.6.0","sha":"8569e22","branch":"develop","env":"dev","builtAt":"2026-11-03T10:33:21.441Z"}